import React from 'react';

const SIZE_TO_PADDING = {
  sm: 'px-1 py-0.5',
  md: 'px-2 py-1',
  lg: 'px-3 py-1.5',
  xl: 'px-4 py-2',
};

const SIZE_TO_TEXT = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
  xl: 'text-xl',
};

const MIN_WIDTH_ANONYMOUS = { minWidth: '80px' };

function defaultAriaLabel(mode, value) {
  switch (mode) {
    case 'BRAND': return 'MOGGED';
    case 'ANONYMOUS': return 'anonymous portrait';
    case 'SCORE': return `score: ${value}`;
    case 'LABEL': return value != null ? String(value) : '';
    case 'RANK': return `rank: ${value}`;
    default: return '';
  }
}

function renderContent(mode, value) {
  switch (mode) {
    case 'BRAND': return 'MOGGED';
    case 'ANONYMOUS': return '';
    case 'SCORE':
    case 'LABEL':
    case 'RANK':
      return value != null ? String(value) : '';
    default: return '';
  }
}

const CensorBar = ({
  mode,
  value,
  size = 'md',
  className = '',
  ariaLabel,
}) => {
  const padding = SIZE_TO_PADDING[size] || SIZE_TO_PADDING.md;
  const text = SIZE_TO_TEXT[size] || SIZE_TO_TEXT.md;
  const content = renderContent(mode, value);
  const label = ariaLabel != null ? ariaLabel : defaultAriaLabel(mode, value);

  const baseClasses = [
    'inline-flex',
    'items-center',
    'justify-center',
    'bg-obsidian',
    'text-bone-pure',
    'font-censor',
    'font-bold',
    'uppercase',
    'tracking-normal',
    'rounded-none',
    'border-0',
    'shadow-none',
    padding,
    text,
    className,
  ].filter(Boolean).join(' ');

  return (
    <span
      role="img"
      aria-label={label}
      className={baseClasses}
      style={mode === 'ANONYMOUS' ? MIN_WIDTH_ANONYMOUS : undefined}
      data-mode={mode}
      data-size={size}
    >
      {content}
    </span>
  );
};

export default CensorBar;
